import React from 'react';
import {
  useFieldController,
  useFormMethods,
} from '../../../../../../helpers/formManager';
import { fieldNames } from '../../constants';
import Field from '../../../../shared/ui/Field';

const name = fieldNames.availableToClient;

const dependednFieldNames = [fieldNames.fromDate, fieldNames.toDate];

const AvailableToClientField = () => {
  const { field } = useFieldController({ name, defaultValue: true });

  const { unregister } = useFormMethods();

  const handleChange = (e) => {
    const value = e.target.checked;
    field.onChange(value);

    if (value === false) {
      unregister(dependednFieldNames);
    }
  };

  return (
    <Field.Memoized
      type={Field.types.checkbox}
      checked={field.value}
      onChange={handleChange}
    >
      Показывать собственнику
    </Field.Memoized>
  );
};

export default AvailableToClientField;
